module.exports = __webpack_public_path__ + "static/yellow-accb64767ba443acc94690995024b60a.svg";